import React from 'react';
import '/node_modules/flag-icons/css/flag-icons.min.css';
import { Text } from 'components/text';
import { CountryCode, getCountries } from './CountrySelect';
import { Locales } from './types';
import styled from '@emotion/styled';

export interface FlagWithCountryProp extends React.HTMLProps<HTMLSpanElement> {
  nationality?: CountryCode | string;
  locale?: Locales;
  hideFlag?: boolean;
}

export const FlagWithCountry = ({
  nationality,
  locale,
  hideFlag,
  ...rest
}: FlagWithCountryProp) => {
  const country = getCountries(locale)?.find(item => item.country === nationality);
  if (!nationality) {
    return null;
  }
  if (hideFlag) {
    return country?.title ?? '';
  }
  return (
    <Container data-testid="flag-with-country">
      <span
        {...rest}
        style={{ maxWidth: '30px', minWidth: '30px', height: '20px', ...rest?.style }}
        className={`fi fi-${nationality?.toLowerCase()}`}
      />
      <Text variant="bodyXs" weight="regular" color="secondary">
        {country?.title}
      </Text>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;
